export enum STUDENT_EXTRA_HELP_MODES {
  Generate_Solution_From_AI = 'generate-solution',
  Ask_Teacher = 'ask-teacher',
  Ask_Student = 'ask-student',
}
